'use strict';

var jsxRuntime = require('react/jsx-runtime');

const SmallLike = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.62 9.79002C13 8.93002 12.95 8.42002 12.95 8.42002V6.91002C12.95 5.91002 12.26 5.73002 11.89 5.70002H7.86004L8.25004 2.89002C8.41004 1.82002 8.05004 1.38002 7.87004 1.23002L7.48004 0.910022L7.43004 0.870022C7.09004 0.580022 6.86004 1.08002 6.85004 1.10002L4.31004 6.36002V13.25H9.94004C10.46 13.25 10.82 12.92 11.03 12.67C11.16 12.51 11.22 12.38 11.22 12.38L12.33 10.36C12.44 10.18 12.52 10.01 12.59 9.84002L12.61 9.81002L12.62 9.79002ZM3.65004 13.24H2.10004C1.82004 13.24 1.55004 13.12 1.35004 12.92C1.15004 12.72 1.04004 12.45 1.04004 12.17V7.42002C1.04004 6.83002 1.51004 6.35002 2.09004 6.35002H3.64004",
            fill: "currentColor"
        }) : jsxRuntime.jsx("path", {
            d: "M4.62999 6.42999L6.86999 1.78999C6.86999 1.77999 7.07999 1.32999 7.37999 1.58999L7.41999 1.62999L7.75999 1.90999C7.91999 2.03999 8.23999 2.42999 8.09999 3.36999L7.74999 5.84999H11.31C11.63 5.87999 12.24 6.03999 12.24 6.91999V8.24999C12.24 8.24999 12.29 8.70999 11.95 9.45999H11.96L11.94 9.48999C11.88 9.62999 11.81 9.77999 11.71 9.93999L10.73 11.73C10.73 11.73 10.67 11.85 10.56 11.99C10.38 12.22 10.06 12.51 9.59999 12.51H4.62999V6.42999ZM4.62999 6.42999H2.66999C2.15999 6.42999 1.73999 6.84999 1.73999 7.36999V11.56C1.73999 11.81 1.83999 12.04 2.00999 12.22C2.18999 12.4 2.41999 12.5 2.66999 12.5H4.62999",
            stroke: "currentColor",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

module.exports = SmallLike;
